import {Component, OnInit, input} from '@angular/core';
import {Observable} from 'rxjs';
import * as fromProfile from '../store/profile.reducers';
import {Store} from '@ngrx/store';
import * as fromApp from '../../store/app.reducers';
import * as ProfileAction from '../store/profile.actions';

@Component({
    selector: 'app-audit-example',
    templateUrl: './audit-example.component.html',
    styleUrls: ['./audit-example.component.scss'],
    standalone: false
})
export class AuditExampleComponent implements OnInit {

  readonly name = input<string>();
  profileState: Observable<fromProfile.State>;

  constructor(
    private store: Store<fromApp.AppState>
  ) { }

  ngOnInit() {
    this.profileState = this.store.select('profile');
  }

  setExampleStatus(status: boolean) {
    this.store.dispatch(
      new ProfileAction.SetAuditBoxExampleStatus({
        boxName: this.name(),
        status: status
      })
    );
  }

}
